import { Outlet } from "react-router";

import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const BillingReportsLayout = () => {
    const navList = useNav();
    let { billingReportsBottomNav, topBillingReportsNav } = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={billingReportsBottomNav} topTabs={topBillingReportsNav} />
            <Outlet />
        </div>
    );
}

export default BillingReportsLayout;